import { Component, OnInit } from '@angular/core';
import {InitService} from "../../services/init.service";
import {CognitoService} from "../../services/cognito.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  authState: boolean =false;

  constructor(private serviceInit: InitService, private router: Router) {
    this.serviceInit.setEstadoLayout(true);

  }

  ngOnInit(): void {
/*     this.authService.isAuthenticated()
      .then((valor: boolean) => {
        this.authState = valor;
        console.log('estado de auth',this.authState);
      });

    this.authService.getRol()
      .then((userRol: any) => {
        console.log('role',userRol);
      }); */
  }

  navigateTo(direction:string) {
    this.router.navigate([`/${direction}`])
      .then(() => console.log('Navigated to' + direction));
}

}
